import React from "react";
import ReactTooltip from "react-tooltip"
import GitHubCalendar from 'react-github-calendar';
import styles from "./Statistics.module.css"
const Stats = () => {
  return (
    <>
                        <div>
                              <p >My Stats  </p>
                          </div>
    <div >
      <div>
        <a href="https://github.com/RavinderTakda">

          <img
           className={styles.language}
            src="https://github-readme-streak-stats.herokuapp.com/?user=RavinderTakda&theme=horizon"
          />
        </a>
      </div>
 
      <div className={styles.chart}
      >
        <a href="https://github.com/RavinderTakda">  
          <img
         className={styles.gitstats}
            src="https://github-readme-stats.vercel.app/api/top-langs/?username=RavinderTakda&custom_title=Most_language_Used&theme=cobalt"  //launguages
          />
        </a>
        <a href="https://github.com/RavinderTakda">
          <img
            align="left"
            className={styles.gitstats1}
            src="https://github-readme-stats.vercel.app/api?username=RavinderTakda&count_private=true&show_icons=true&theme=cobalt" //stats
          />
        </a>
      </div>

      <div className={styles.graph}>

                          <GitHubCalendar  username="RavinderTakda" ><ReactTooltip delayShow={20} html /></GitHubCalendar>
                          </div>
    </div>
    </>
  );
};

export default Stats;